import React from 'react';
import { createRoot } from 'react-dom/client';
import { createStore } from 'redux';
import { Provider } from 'react-redux';

import 'toastr/build/toastr.min.css';

import App from './App';
import registerServiceWorker from './registerServiceWorker';
import reducer from './store/reducer';

import './index.css';

const store = createStore(reducer);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);

registerServiceWorker();
